module.exports = {"title":"Pricing","errorRequired":"This field is required.","errorInvalid":"The format is invalid.","table":{"titleName":"Name","titlePrice":"Price"},"helps":[{"title":"Tip","content":"<p>Examples: Adult, Senior, Student, Military, etc.</p>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateFlexpass/FlexpassPricing/locales/fr.json
// module id = 1721
// module chunks = 0